/* eslint-disable react/require-default-props,react/destructuring-assignment,react/no-array-index-key,react/jsx-no-target-blank,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/anchor-is-valid */

import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ScrollButton } from '../../components/Links/ScrollButton';
import {
  PortalCourseLinksPropType,
  PortalInstitutionPropType,
} from '../../../CustomPropTypes/PortalPropTypes';
import { LoadableResponsiveImage as ResponsiveImage } from '../../components/ResponsiveImage/LoadableResponsiveImage';
import './PortalNavBar.scss';

class _PortalNavBar extends React.Component {
  static displayName = 'PortalNavBar';

  static propTypes = {
    portalInstitution: PortalInstitutionPropType.isRequired,
    links: PortalCourseLinksPropType.isRequired,
    callToAction: PropTypes.string,
    onCallToAction: PropTypes.func,
    onCtaButtonClicked: PropTypes.func,
    t: PropTypes.func.isRequired,
  };

  onCallToAction = () => {
    if (this.props.onCtaButtonClicked && this.props.callToAction) {
      this.props.onCtaButtonClicked(this.props.callToAction, 'navbar');
    }
    if (this.props.onCallToAction) {
      this.props.onCallToAction();
    }
  };

  translatedTitle = (title) => {
    const { t, callToAction } = this.props;

    switch (title) {
      case 'About':
        return callToAction ? t('about') : title;
      case 'Outcomes':
        return callToAction ? t('outcomes') : title;
      case 'Instructors':
        return callToAction ? t('instructors') : title;
      case 'Certification':
        return callToAction ? t('certification') : title;
      case 'FAQ':
        return callToAction ? t('faq') : title;
      default:
        return title;
    }
  };

  render() {
    const { portalInstitution, links, callToAction } = this.props;

    return (
      <portal-nav-bar>
        <div className="nav-bar">
          <div className="row">
            <div className="columns small-12 medium-12 medium-centered">
              <div className="nav-bar-wrapper">
                <ul className="nav-bar-links">
                  {portalInstitution.get('logoUrl') && (
                    <li>
                      <a
                        className="institution-logo"
                        href={portalInstitution.get('url')}
                      >
                        <ResponsiveImage
                          src={portalInstitution.get('logoUrl')}
                          resize="h:128"
                          alt={portalInstitution.get('institutionName')}
                        />
                      </a>
                    </li>
                  )}
                  {links.map((link, index) => (
                    <li key={index}>
                      {link.get('onPage', true) ? (
                        <ScrollButton
                          to={link.get('link').replace('#', '')}
                          spy
                          smooth
                          duration={500}
                          isDynamic
                        >
                          {this.translatedTitle(link.get('title'))}
                        </ScrollButton>
                      ) : (
                        <a href={link.get('link')} target="_blank">
                          {this.translatedTitle(link.get('title'))}
                        </a>
                      )}
                    </li>
                  ))}
                  {callToAction ? (
                    <li>
                      <a className="nav-bar-cta" onClick={this.onCallToAction}>
                        {callToAction}
                      </a>
                    </li>
                  ) : null}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </portal-nav-bar>
    );
  }
}

export const PortalNavBar = withTranslation('landingPages')(_PortalNavBar);
